// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"af9a033e","213":"15ded391","239":"c22527af","308":"439d12e2","369":"7b4942da","488":"d5488888","553":"4c2f071c","750":"6c027763","924":"f63a9cf1"}[chunkId] + ".chunk.js";
};